// @flow

export const user = (state: StoreType): any => state?.user;
export const userProfile = (state: StoreType): any => user(state)?.profile;
export const getUserName = (state: StoreType): any => userProfile(state)?.username;
export const getRole = (state: StoreType): any => userProfile(state)?.role;
export const getToken = (state: StoreType): any => userProfile(state)?.token;
export const getLoginError = (state: StoreType): any => user(state)?.loginError;
export const loginErrorMessage = (state: StoreType): any => getLoginError(state)?.message;
export const getUsersLotNumber = (state: StoreType): any => userProfile(state)?.lotNumber;
export const getChangePasswordSuccess = (state: StoreType): any => user(state)?.changePassword.successMessage;
export const getChangePasswordError = (state: StoreType): any => user(state)?.changePassword.errorMessage;
export const getForgotPasswordSuccess = (state: StoreType): any => user(state)?.forgotPassword.successMessage;
export const getForgotPasswordError = (state: StoreType): any => user(state)?.forgotPassword.errorMessage;
export const isAuthenticated = (state: StoreType): any => userProfile(state) !== null && userProfile(state) !== undefined;
